function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.088 12.127a12.6 12.6 0 01.657-1.12 17.01 17.01 0 011.876-2.41C6.718 6.36 9.183 5 12 5c2.817 0 5.282 1.36 7.379 3.597a17.01 17.01 0 011.876 2.41c.32.495.54.886.657 1.12a.833.833 0 010 .746 12.6 12.6 0 01-.657 1.12 17.01 17.01 0 01-1.876 2.41C17.282 18.64 14.817 20 12 20c-2.817 0-5.282-1.36-7.379-3.597a17.077 17.077 0 01-1.876-2.41 12.6 12.6 0 01-.657-1.12.833.833 0 010-.746zm2.057.963a15.427 15.427 0 001.692 2.173c1.81 1.93 3.875 3.07 6.163 3.07 2.288 0 4.353-1.14 6.163-3.07a15.427 15.427 0 002.053-2.763 15.427 15.427 0 00-2.053-2.763c-1.81-1.93-3.875-3.07-6.163-3.07-2.288 0-4.353 1.14-6.163 3.07A15.427 15.427 0 003.784 12.5c.105.181.225.38.361.59zM12 15.833a3.333 3.333 0 110-6.666 3.333 3.333 0 010 6.666zm0-1.666a1.667 1.667 0 100-3.334 1.667 1.667 0 000 3.334z"
});

var SvgEye = function SvgEye(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/eye.fac2dd09.svg";
export { SvgEye as ReactComponent };